import { create } from "zustand"
import { persist } from "zustand/middleware"

interface SuperUserFormState {
	phone: string
	abta: string
	setPhone: (phone: string) => void
	setAbta: (abta: string) => void
	resetForm: () => void
}

export const useSuperUserStore = create<SuperUserFormState>()(
	persist(
		(set) => ({
			phone: "",
			abta: "",
			setPhone: (phone: string) => set({ phone }),
			setAbta: (abta: string) => set({ abta }),
			resetForm: () => set({ phone: "", abta: "" })
		}),
		{
			name: "super-user-form-storage"
		}
	)
)
